import { Sparkles } from 'lucide-react';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { useSummarizeTicket } from '@/hooks/tickets';

interface Props {
  ticketId: string;
  body: string;
  aiSummary: string | null;
  suggestedReply: string | null;
}

export function TicketBody({ ticketId, body, aiSummary, suggestedReply }: Props) {
  const summarizeMutation = useSummarizeTicket(ticketId);

  const sectionLabel = 'text-[10px] font-bold tracking-[0.12em] uppercase mb-2';
  const sectionLabelStyle = { color: 'var(--muted-foreground)' };
  const blockStyle = {
    background: 'var(--card)',
    border: '1px solid var(--border)',
  };

  return (
    <>
      <div>
        <p className={sectionLabel} style={sectionLabelStyle}>Message</p>
        <div className='rounded-lg p-4 text-sm whitespace-pre-wrap leading-relaxed' style={blockStyle}>
          {body}
        </div>
        <div className='mt-2'>
          <Button
            variant='outline'
            size='sm'
            onClick={() => summarizeMutation.mutate()}
            disabled={summarizeMutation.isPending}
          >
            <Sparkles className='h-3.5 w-3.5 mr-1.5' />
            {summarizeMutation.isPending
              ? 'Summarizing…'
              : aiSummary
                ? 'Re-generate summary'
                : 'Summarize'}
          </Button>
          {summarizeMutation.isError && (
            <p className='text-xs text-destructive mt-1'>
              {axios.isAxiosError(summarizeMutation.error)
                ? (summarizeMutation.error.response?.data?.error ?? 'Failed to summarize.')
                : 'Failed to summarize.'}
            </p>
          )}
        </div>
      </div>

      {aiSummary && (
        <div>
          <p className={sectionLabel} style={sectionLabelStyle}>AI Summary</p>
          <div
            className='rounded-lg p-4 text-sm leading-relaxed'
            style={{
              background: 'oklch(0.65 0.22 285 / 0.06)',
              border: '1px solid oklch(0.65 0.22 285 / 0.2)',
            }}
          >
            {aiSummary}
          </div>
        </div>
      )}

      {suggestedReply && (
        <div>
          <p className={sectionLabel} style={sectionLabelStyle}>Suggested Reply</p>
          <div className='rounded-lg p-4 text-sm whitespace-pre-wrap leading-relaxed' style={blockStyle}>
            {suggestedReply}
          </div>
        </div>
      )}
    </>
  );
}
